var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { throwError, ReplaySubject, of, forkJoin } from 'rxjs';
import { map, flatMap, tap, catchError } from 'rxjs/operators';
import { AccountService } from './account.service';
import { UserService } from './user.service';
import { WebApi } from 'app/core/web-api.service';
var AuthService = /** @class */ (function () {
    function AuthService(_accountService, _userService, _webApi) {
        var _this = this;
        this._accountService = _accountService;
        this._userService = _userService;
        this._webApi = _webApi;
        this._isAuth = new ReplaySubject(1);
        this._webApi.events.subscribe(function (eventName) {
            if (eventName === 'error'
                || eventName === 'logout') {
                _this._isAuth.next(false);
            }
        });
    }
    Object.defineProperty(AuthService.prototype, "isAuth", {
        get: function () {
            return this._isAuth.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.init = function () {
        return this._init().pipe(catchError(function () { return of(void 0); })).toPromise();
    };
    AuthService.prototype.login = function (email, password) {
        var _this = this;
        return this._webApi.login(email, password).pipe(flatMap(function () { return _this._init(); }));
    };
    AuthService.prototype.logout = function () {
        var _this = this;
        return this._webApi.logout().pipe(tap(function () { return _this._isAuth.next(false); }));
    };
    AuthService.prototype.register = function (user) {
        var _this = this;
        this._removeEmptyFields(user);
        return this._webApi
            .register(user)
            .pipe(flatMap(function () { return _this._init(); }));
    };
    AuthService.prototype.recoverPassword = function (email, resetPasswordUrl) {
        return this._webApi.recoverPassword(email, resetPasswordUrl);
    };
    AuthService.prototype.changePassword = function (password, token) {
        return this._webApi.changePassword(password, token);
    };
    AuthService.prototype._init = function () {
        var _this = this;
        return forkJoin([
            this._accountService.init(),
            this._userService.init()
        ]).pipe(map(function () {
            _this._isAuth.next(true);
        }), catchError(function (response) {
            _this._isAuth.next(false);
            return throwError(response);
        }));
    };
    AuthService.prototype._removeEmptyFields = function (obj) {
        var e_1, _a;
        function isEmpty(value) {
            return value === null
                || value === undefined
                || value === '';
        }
        try {
            for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (isEmpty(obj[key])) {
                    delete obj[key];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return AuthService;
}());
export { AuthService };
